import { Component, ElementRef, ViewChild } from '@angular/core';
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { EventService } from '../../shared/services/event.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { environment } from '../.././../environments/environment'
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ps-view-shared-features',
  templateUrl: './view-shared-features.component.html',
  styleUrls: ['./view-shared-features.component.scss']
})
export class ViewSharedFeaturesComponent {
  @ViewChild('myDiv') myDiv !: ElementRef;

  public events: any;
  public eventData!: any[];
  public eventId: any;
  public data: any;
  public arr: any = [];
  public imageUrl: any = [];
  public eventImage: any = [];
  public template: any;
  public role!: string;
  public shareLinks: any = [];
  public shareData: any;
  public isApproved: boolean = false;
  public openNav: boolean = false;


  constructor(private router: Router, public domSanitizer: DomSanitizer, private location: Location, private EventService: EventService, private toastr: ToastrService, private route: ActivatedRoute, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {

    this.route.params.subscribe((param) => {
      this.eventId = param.id
    })
    this.getInstitutionEventsById();
    this.shareData = {
      url: environment.fDomainName + 'auth/sharedArticle/' + this.eventId,
      description: 'dev',
      tags: 'Eltai',
    };

    this.shareLinks = [
      {
        link: `https://www.facebook.com/sharer.php?u=${this.shareData?.url}`,
        icon: 'fa fa-facebook-square'
      },
      {
        icon: 'fab fa-x-twitter',
        link: `https://twitter.com/intent/tweet?url=${this.shareData?.url}`,
      },
      {
        icon: 'fa fa-pinterest-square',
        link: `http://pinterest.com/pin/create/link/?url=${this.shareData?.url}`,
      },
      {
        icon: 'fa fa-whatsapp',
        link: `https://wa.me?text=${this.shareData?.url}`,
      },
    ];
  }

  openMobileNav() {
    this.openNav = !this.openNav;
  }


  // getAllEventsInstitution
  getInstitutionEventsById() {
    this.eventData = []
    this.eventImage = []
    var data = {
      id: this.eventId
    }
    this.EventService.getInstitutionEventsById(data).subscribe(res => {
      if (res.status) {
        this.events = res.data
        res.data.urlArray.forEach((ele: any) => {
          this.eventImage.push({ url: ele.url })
        })
        if (res.data.isApporovedBySPOC == 1) {
          this.isApproved = true
        }
        else {
          this.isApproved = false
        }
        this.arr.push(this.events)
        this.arr.forEach((item: any) => {
          this.eventData.push({
            instituteName: item.institutionName,
            eventText: item.eventText,
            title: item.title
          })
          this.template = this.domSanitizer.bypassSecurityTrustHtml(item.eventText);
        });
      }
    })
  }


  //  back 
  addedit() {
    this.router.navigateByUrl("/auth/publishedArticle");
  }

}
